export default __webpack_public_path__ + "static/media/seta.f3c23d44.svg";